module.exports = __webpack_public_path__ + "assets/img/2210.ac8521a5.svg";